import { Tabs, Space, Modal, Form, Input, Button, Select, Card, Table, Image, Row, Checkbox, Tooltip, message } from "antd";
import { SearchOutlined, ReloadOutlined, DownloadOutlined, PlusOutlined, ExclamationCircleOutlined, ImportOutlined, CloudUploadOutlined } from "@ant-design/icons";
import ProductSearchModal from "../components/ProductSearchModal";
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import service from "../../../@services";
import { useEffect, useState } from "react";
import * as Utils from '../../../@utils'
import AuthComponent from "../../../components/AuthComponent";
import "./index.less";
import BatchUploadModal from "../components/BatchUpload";
import BatchEditArea from "../components/BatchEditArea";
import UploadHistory from "../components/UploadHistory";
const statusMap = {
  '0': "下架",
  '1': "上架",
  '2': "紧急下架",
  '3': "可售",
}
const chanMap = [
  { label: '线上', value: '1' },
  { label: '线下', value: '0' }
]
const { Option } = Select;
const { TabPane } = Tabs;
export default function ProductStore(props) {
  const barcode = props.location.query?.barcode
  const getStoreId = props.location.query?.storeId
  const [form] = Form.useForm();
  const [productSearchModalVisible, setProductSearchModalVisible] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [storeId, onSelectStore] = useState("")
  const [tabActiveKey, setTabActiveKey] = useState()
  const [loading, setLoading] = useState(false)
  const [tabsCount, setTabsCount] = useState({ initialCount: '', onShelvesCount: '', offShelvesCount: '' })
  const [tableData, setTableData] = useState([])
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, })
  const [title, setTitle] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [defaultOnline, setDefaultOnline] = useState([])
  const [onlineId, setOnlineId] = useState('')
  const [batchUploadProps, setBatchUpload] = useState({ visible: false })
  const [historyModalVisible, setUploadHistoryVisible] = useState(false)
  const [batchEditAreaVisible, setBatchEditAreaVisible] = useState(false)
  useEffect(() => {
    onSearch()
  }, [tabActiveKey, storeId]);
  const setDefaultStore = (res) => {
    if (getStoreId) {
      form.setFieldsValue({
        storeId: getStoreId
      })
      onSelectStore(getStoreId)
    } else {
      form.setFieldsValue({
        storeId: res.id
      })
      onSelectStore(res.id)
    }

  }
  const onSearch = () => {
    if (!storeId) {
      //message.warning('请选择门店');
      return
    }
    const params = Object.assign({}, form.getFieldsValue(), { pageIndex: 1, pageSize: 10 })
    fetchData(params)
  }
  const onReset = () => {
    form.resetFields();
  };
  const handleTableChange = (pagination) => {
    setPagination(pagination)
    const params = Object.assign({}, form.getFieldsValue(), { pageIndex: pagination.current, pageSize: pagination.pageSize })
    fetchData(params)
  }
  const fetchData = async (params) => {
    params.onShelves = parseInt(tabActiveKey)
    console.log(params)
    setLoading(true)
    const data = await service.product.getStoreProductList(params)
    setLoading(false)
    if (data) {
      setTableData(data.list.result)
      setTabsCount({
        initialCount: data.initialCount,
        onShelvesCount: data.onShelvesCount,
        offShelvesCount: data.offShelvesCount,
      })
      setPagination({
        current: data.list.pageIndex,
        pageSize: data.list.pageSize,
        total: data.list.recordCount
      })
    }
  }
  const deleteProduct = async (skuId) => {
    if (!skuId && selectedRowKeys.length === 0) {
      message.warning('请选择商品');
      return
    }
    const skuIds = skuId ? [skuId] : selectedRowKeys
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认要删除吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        await service.product.deleteStoreProduct({ skuIds, storeId })
        message.success('操作成功');
        onSearch()
      }
    });
  };
  const shelvesUpdate = async (skuId, onShelves) => {
    if (!skuId && selectedRowKeys.length === 0) {
      message.warning('请选择商品');
      return
    }
    const skuIds = skuId ? [skuId] : selectedRowKeys
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: `确认要${onShelves == 1 ? '上架' : '下架'}吗？`,
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        onShelves == 1
          ? await service.product.batchStoreOnShelves({ skuIds, storeId })
          : await service.product.batchStoreOffShelves({ skuIds, storeId })
        message.success('操作成功');
        onSearch()
      }
    });
  };
  const changeOnlineValue = (e) => {
    setDefaultOnline(e)
  }
  const changeOnline = (data, onShelves, onlineSaleable) => {
    // onlineSaleable 0线下 1线上 2全部
    setOnlineId(data.skuId)
    // onlineShelves=1上架 2下架
    if (onlineSaleable === '0' || onlineSaleable === '1') {
      Modal.confirm({
        title: '提示',
        icon: <ExclamationCircleOutlined />,
        content: `确认要${onShelves === 1 ? '上架' : '下架'}吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          const params = {
            channel: onlineSaleable,
            skuIds: [data.skuId],
            storeId: storeId
          }
          onShelves === 1
            ? await service.product.batchStoreOnShelves(params)
            : await service.product.batchStoreOffShelves(params)
          message.success('操作成功');
          onSearch()
        }
      });
    } else {
      onShelves === 1 ? setTitle('门店上架') : setTitle('门店下架')
      setIsModalVisible(true);
      if (onShelves === 1) {
        (data.onlineShelves === 0 || data.onlineShelves === 3) && (data.storeShelves === 0 || data.storeShelves === 3) ?
          setDefaultOnline(['0', '1']) :
          (data.onlineShelves === 0 && data.storeShelves === 1) ?
            setDefaultOnline(['1']) :
            (data.onlineShelves === 1 && data.storeShelves === 0) ?
              setDefaultOnline(['0']) :
              setDefaultOnline([])
      } else {
        (data.onlineShelves === 1 && data.storeShelves === 1) ?
          setDefaultOnline(['0', '1']) :
          (data.onlineShelves === 0 && data.storeShelves === 1) ?
            setDefaultOnline(['0']) :
            (data.onlineShelves === 1 && data.storeShelves === 0) ?
              setDefaultOnline(['1']) :
              setDefaultOnline([])
      }
    }
  }
  const handleOk = async () => {
    const chan = defaultOnline.length >= 2 ? '2' : defaultOnline.includes('1') ? '1' : '0'
    const params = {
      channel: chan,
      skuIds: [onlineId],
      storeId: storeId
    }
    title === '门店上架' ?
      await service.product.batchStoreOnShelves(params)
      : await service.product.batchStoreOffShelves(params)
    message.success('操作成功');
    setIsModalVisible(false)
    onSearch()
  }
  const addProduct = () => {
    if (!storeId) {
      message.warning('请选择门店');
      return
    }
    setProductSearchModalVisible(true)
  }
  const pushStore = async (skuIds) => {
    await service.product.createForStore({ skuIds, storeIds: [storeId] })
    setProductSearchModalVisible(false)
    message.success('操作成功');
    onSearch()
  };
  const createProduct = () => {
    setProductSearchModalVisible(false)
    props.history.push(`/product/store-product/create?type=store&storeId=${storeId}`)
  };
  const editProduct = (skuId) => {
    props.history.push(`/product/store-product/edit?type=store&storeId=${storeId}&skuId=${skuId}`)
  };
  const viewProduct = (skuId) => {
    props.history.push(`/product/store-product/detail?type=store&skuId=${skuId}`)
  };

  const editAreaProduct = () =>{
    if (selectedRowKeys.length === 0) {
      message.warning('请选择商品');
      return
    }
    setBatchEditAreaVisible(true)
  }

  const closeBatchEditArea = (clear = false) => {
    if(clear === true){
      setSelectedRowKeys([])
    }
    setBatchEditAreaVisible(false)
  }

  const exportProduct = async () => {
    const params = Object.assign({}, form.getFieldsValue(), { onShelves: tabActiveKey })
    const file = await service.product.exportStoreProduct(params)
    const filename = '门店商品报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  };
  const onTabChange = (key) => {
    setTabActiveKey(key)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => { 
      setSelectedRowKeys(newSelectedRowKeys)
    },
  };
  const columns = [
    {
      title: '商品主图',
      dataIndex: 'mainPictureUrl',
      width: '120px',
      key: 'mainPictureUrl',
      render: (mainPictureUrl) => (
        <Image
          width={59}
          src={mainPictureUrl || '/assets/error-img.png'}
        />
      )
    },
    {
      title: '商品信息',
      dataIndex: '',
      width: '100%',
      key: 'productInfo',
      render: (text, record, index) => (
        <>
          <Row>商品名称：{record.name || '-'}</Row>
          <Row>商品编码：{record.outProductNo || '-'}</Row>
          <Row>商品条码：{record.barcode || '-'}</Row>
        </>
      )
    },
    {
      title: '规格',
      dataIndex: '',
      width: '255px',
      key: 'productInfo',
      render: (text, record, index) => (
        <>
          <Row>规格：{record.specification || '-'}</Row>
          <Row>单位：{record.packageUnitName || '-'}</Row>
        </>
      )
    },
    {
      title: '价格',
      dataIndex: '',
      key: 'productInfo',
      width: '160px',
      render: (text, record, index) => (
        <>
          <Row>售价：{record.salePrice || '-'}</Row>
          <Row>零售指导价：{record.retailPrice || '-'}</Row>
          <Row>
            <Tooltip title="移动平均价">成本价：{record.costPrice || '-'}</Tooltip>
          </Row>
          <Row>采购进货价：{record.purchasePrice || '-'}</Row>
        </>
      )
    },
    {
      title: '库存',
      dataIndex: '',
      key: 'productInfo',
      render: (text, record, index) => (
        <>
          <Row>仓库库存：{record.stock || '-'}</Row>
          <Row>线上可售库存：{record.saleableStock || '-'}</Row>
        </>
      )
    },
    {
      title: '配送方式',
      dataIndex: 'deliveryMethod',
      key: 'deliveryMethod',
      render: (text, record, index) => (
        <>
          {['2', '0'].includes(record.deliveryMethod + '') ? <Row>快递配送</Row> : ''}
          {['2', '1'].includes(record.deliveryMethod + '') ? <Row>门店自提</Row> : ''}
          {record.deliveryMethod == null ? '-' : ''}
        </>
      )
    },
    {
      title: '售卖渠道',
      dataIndex: 'onlineShelves',
      key: 'onlineShelves',
      render: (text, record, index) => (
        <>
          <Row>售卖渠道：{record.onlineSaleable === 0 ? '线下' : record.onlineSaleable === 1 ? '线上' : record.onlineSaleable === 2 ? '线上/线下' : ''}</Row>
        </>
      )
    },
    {
      title: '门店状态',
      dataIndex: '',
      key: 'productInfo',
      render: (text, record, index) => (
        <>
          <Row>线上：{statusMap[record.onlineShelves] || '-'}</Row>
          <Row>线下：{statusMap[record.storeShelves] || '-'}</Row>
        </>
      )
    },
    {
      title: '操作',
      dataIndex: 'options',
      fixed: 'right',
      width: 160,
      key: 'options',
      render: (text, record, index) => {
        // onlineSaleable 0线下 1线上 2全部
        if (record.onlineSaleable === 0) {
          return (
            <Space style={{ flexWrap: 'wrap' }}>
              {
                record.storeShelves === 1
                  ?
                  <AuthComponent authKey="/product/store-product/batch-off-shelves"><Button onClick={() => changeOnline(record, 0, '0')} type="link">门店下架</Button></AuthComponent>
                  :
                  record.storeShelves === 0 || record.storeShelves === 3
                    ?
                    <AuthComponent authKey="/product/store-product/batch-on-shelves"><Button onClick={() => changeOnline(record, 1, '0')} type="link">门店上架</Button></AuthComponent>
                    :
                    <></>
              }
              <AuthComponent authKey="/product/store-product/detail/{id}"><Button onClick={() => viewProduct(record.skuForStoreId)} type="link">详情</Button></AuthComponent>
              <AuthComponent authKey="/product/store-product/update"><Button onClick={() => editProduct(record.skuForStoreId)} type="link">编辑</Button></AuthComponent>
              <AuthComponent authKey="/product/store-product/delete"><Button onClick={() => deleteProduct(record.skuId)} type="link">删除</Button></AuthComponent>
            </Space>
          )
        } else if (record.onlineSaleable === 1) {
          return (
            <Space style={{ flexWrap: 'wrap' }}>
              {
                record.onlineShelves === 1
                  ?
                  <AuthComponent authKey="/product/store-product/batch-off-shelves"><Button onClick={() => changeOnline(record, 0, '1')} type="link">门店下架</Button></AuthComponent>
                  :
                  record.onlineShelves === 0 || record.onlineShelves === 3
                    ?
                    <AuthComponent authKey="/product/store-product/batch-on-shelves"><Button onClick={() => changeOnline(record, 1, '1')} type="link">门店上架</Button></AuthComponent>
                    :
                    <></>
              }
              <AuthComponent authKey="/product/store-product/detail/{id}"><Button onClick={() => viewProduct(record.skuForStoreId)} type="link">详情</Button></AuthComponent>
              <AuthComponent authKey="/product/store-product/update"><Button onClick={() => editProduct(record.skuForStoreId)} type="link">编辑</Button></AuthComponent>
              <AuthComponent authKey="/product/store-product/delete"><Button onClick={() => deleteProduct(record.skuId)} type="link">删除</Button></AuthComponent>
            </Space>
          )
        } else {
          return (
            <Space style={{ flexWrap: 'wrap' }}>
              {
                // onlineSaleable 0线下 1线上 2全部
                record.onlineShelves === 1 && record.storeShelves === 1
                  ?
                  <AuthComponent authKey="/product/store-product/batch-off-shelves"><Button onClick={() => changeOnline(record, 0)} type="link">门店下架</Button></AuthComponent>
                  :
                  (record.onlineShelves === 0 || record.onlineShelves === 3) && (record.storeShelves === 0 || record.storeShelves === 3)
                    ?
                    <AuthComponent authKey="/product/store-product/batch-on-shelves"><Button onClick={() => changeOnline(record, 1)} type="link">门店上架</Button></AuthComponent>
                    :
                    <>
                      <AuthComponent authKey="/product/store-product/batch-on-shelves"><Button onClick={() => changeOnline(record, 1)} type="link">门店上架</Button></AuthComponent>
                      <AuthComponent authKey="/product/store-product/batch-off-shelves"><Button onClick={() => changeOnline(record, 0)} type="link">门店下架</Button></AuthComponent>
                    </>
              }

              <AuthComponent authKey="/product/store-product/detail/{id}"><Button onClick={() => viewProduct(record.skuForStoreId)} type="link">详情</Button></AuthComponent>

              <AuthComponent authKey="/product/store-product/update"><Button onClick={() => editProduct(record.skuForStoreId)} type="link">编辑</Button></AuthComponent>

              <AuthComponent authKey="/product/store-product/delete"><Button onClick={() => deleteProduct(record.skuId)} type="link">删除</Button></AuthComponent>
            </Space>
          )
        }
      }
    },
  ];
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card>
        <Form
          form={form}
          layout="inline"
          initialValues={{ onlineSaleable: '2', deliveryMethod: '2', productInfo: barcode }}
        >
          <Form.Item name="storeId" label="所属门店">
            <ShopSelect style={{ width: 200 }} keyVal='id'
              OnOptionsLoad={setDefaultStore} onChange={onSelectStore} />
          </Form.Item>
          <Form.Item name="productInfo" label="商品信息">
            <Input style={{ width: 200 }} placeholder="商品名称/条码/商品编码" />
          </Form.Item>
          <Form.Item name="onlineSaleable" label="售卖渠道">
            <Select style={{ width: 120 }}>
              <Option value="2">全部</Option>
              <Option value="1">线上</Option>
              <Option value="0">线下</Option>
            </Select>
          </Form.Item>
          <Form.Item name="deliveryMethod" label="配送方式">
            <Select style={{ width: 120 }}>
              <Option value="2">全部</Option>
              <Option value="0">快递配送</Option>
              <Option value="1">门店自提</Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/product/store-product/page">
              <Button type="primary" ghost icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
            </AuthComponent>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/product/store-product/page">
              <Button type="primary" ghost icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </AuthComponent>
          </Form.Item>
        </Form>
      </Card>
      <Tabs
        style={{ marginTop: '-5px', marginBottom: '-23px' }}
        defaultActiveKey={tabActiveKey}
        onChange={onTabChange}
      >
        <TabPane tab="全部" key=""></TabPane>
        <TabPane tab={"可售(" + tabsCount.initialCount + ")"} key={3}></TabPane>
        <TabPane tab={"已上架(" + tabsCount.onShelvesCount + ")"} key={1}></TabPane>
        <TabPane tab={"已下架(" + tabsCount.offShelvesCount + ")"} key={0}></TabPane>
      </Tabs>
      <Space style={{ display: "flex", justifyContent: "space-between", background: "#ffffff", padding: "15px", marginBottom: "-10px" }}>
        <Space>
          <AuthComponent authKey="/product/store-product/create">
            <Button type="primary" onClick={addProduct} icon={<PlusOutlined />}>添加商品</Button>
          </AuthComponent>
          {
            (tabActiveKey === "0" || tabActiveKey === "3") &&
            <AuthComponent authKey="/product/store-product/batch-on-shelves"><Button type="primary" onClick={() => shelvesUpdate(null, 1)}>批量上架</Button>
            </AuthComponent>
          }
          {
            tabActiveKey === "1" &&
            <AuthComponent authKey="/product/store-product/batch-off-shelves">
              <Button type="primary" onClick={() => shelvesUpdate(null, 0)}>批量下架</Button>
            </AuthComponent>
          }
          <AuthComponent authKey="/product/store-product/update">
            <Button type="primary" onClick={() => editAreaProduct()}>批量编辑可售模板</Button>
          </AuthComponent>
          <AuthComponent authKey="/product/store-product/delete">
            <Button type="primary" onClick={() => deleteProduct()}>批量删除</Button>
          </AuthComponent>
          <AuthComponent authKey="/product/store-product/export">
            <Button type="primary" icon={<DownloadOutlined />} onClick={exportProduct}>导出</Button>
          </AuthComponent>
          <AuthComponent authKey="/product/merchant-product/add-file-task">
            <Button type="primary" onClick={() => setBatchUpload({ visible: true, taskType: 9 })} icon={<ImportOutlined />}>批量添加</Button>
          </AuthComponent>
        </Space>
        <AuthComponent authKey="/product/merchant-product/list">
          <Button type="link" icon={<CloudUploadOutlined />} onClick={() => setUploadHistoryVisible(true)}>导入记录</Button>
        </AuthComponent>
      </Space>
      <Table
        rowKey={record => record.skuId}
        dataSource={tableData}
        rowSelection={rowSelection}
        pagination={pagination}
        loading={loading}
        columns={columns}
        scroll={{ x: 1300 }}
        onChange={handleTableChange}
      />

      <ProductSearchModal
        visible={productSearchModalVisible}
        create={createProduct}
        confirm={pushStore}
        close={() => { setProductSearchModalVisible(false) }}
      >
      </ProductSearchModal>

      <Modal title={title} visible={isModalVisible} onOk={handleOk} onCancel={() => setIsModalVisible(false)}>
        <Space>
          售卖渠道：
          <Checkbox.Group
            options={chanMap}
            value={defaultOnline}
            onChange={changeOnlineValue}
          />
        </Space>
      </Modal>
      <UploadHistory visible={historyModalVisible} type={[9]} close={() => { setUploadHistoryVisible(false) }}></UploadHistory>
      <BatchUploadModal visible={batchUploadProps.visible} taskType={batchUploadProps.taskType} storeId={storeId} close={() => { setBatchUpload({ visible: false }) }} />
      <BatchEditArea visible={batchEditAreaVisible} idList={selectedRowKeys} storeId={storeId} close={ (clear) => { closeBatchEditArea(clear) } } />
    </Space>
  );
}
